import _ from "lodash";
import moment from "moment";
import * as Color from "../../components/Color";
import { getDistance } from "../../utils/map-utils";

const yellowPin = require("./img/yellow-pin.png");
const greenPin = require("./img/green-pin.png");
const orangePin = require("./img/orange-pin.png");
const bluePin = require("./img/blue-pin.png");
const grayPin = require("./img/gray-pin.png");

export const yearRanges = [
  {
    min: moment().add(1, "years").year(), // 20
    max: 2999,
    label: "Under construction",
    pin: yellowPin,
    color: Color.COLOR_YEAR_FUTURE,
  },
  {
    min: moment().year(),
    max: moment().year(),
    label: "Completed in This Year",
    pin: greenPin,
    color: Color.COLOR_THIS_YEAR,
  },
  {
    min: moment().subtract(3, "years").year(),
    max: moment().subtract(1, "years").year(),
    label: "Completed Less Than 1-3 Years",
    pin: orangePin,
    color: Color.COLOR_YEAR_0_5,
  },
  {
    min: moment().subtract(5, "years").year(),
    max: moment().subtract(4, "years").year(),
    label: "Completed Less Than 4-5 Year",
    pin: bluePin,
    color: Color.COLOR_YEAR_5_10,
  },
  {
    min: 1000,
    max: moment().subtract(6, "years").year(),
    label: "Completed More Than 5 Year",
    pin: grayPin,
    color: Color.COLOR_YEAR_10UP,
  },
];

const findRangeByYear = (ranges, year) => {
  if (year === "all") return { min: 1000, max: 2999 };
  const yearNumber = _.toNumber(year);
  return _.find(
    ranges,
    (range) => yearNumber <= range.max && yearNumber >= range.min
  );
};

export const getPinByYearComplete = (yearComplete) => {
  const range = findRangeByYear(yearRanges, yearComplete);
  return _.get(range, "pin", grayPin);
};

export const getColorByYearComplete = (yearComplete) => {
  const range = findRangeByYear(yearRanges, yearComplete);
  // // console.log('getColorByYearComplete', { yearComplete, yearRanges, range })
  return _.get(range, "color", Color.COLOR_YEAR_10UP);
};

export const getColorByConstructionStatus = (status) => {
  if (status === "RTM") {
    return Color.COLOR_THIS_YEAR;
  } else if (status === "Under Construction") {
    return Color.COLOR_YEAR_FUTURE;
  } else {
    return "#ED7D31";
  }
};

export const filterProjectsByQuery = (projects, query = {}) => {
  const { budget, yearComplete } = query;
  const budgetOption = _.filter(budget.options, (opt) =>
    _.includes(budget.value, opt.value)
  );

  let yearCompleteOption;
  if (yearComplete.value === "all") {
    yearCompleteOption = [{ max: 2999, min: 1000 }];
  } else {
    yearCompleteOption = _.filter(yearRanges, (opt) => {
      return _.includes(yearComplete.value, `${opt.min}-${opt.max}`);
    });
  }
  return _.filter(projects, (p) => {
    const result =
      (_.some(budgetOption, (bO) => {
        return _.inRange(_.get(p, "resalePriceSqm"), bO.min, bO.max);
      }) ||
        _.size(budgetOption) === 0) &&
      (_.some(yearCompleteOption, (yO) => {
        return _.inRange(_.toNumber(p.yearComplete), yO.min, yO.max + 1);
      }) ||
        _.size(yearCompleteOption) === 0);
    return result;
  });
};

export const filterProjectsByRadiusAndQuery = (
  state,
  dispatch,
  projects,
  { lat, lng },
  radius = 500,
  query = {},
  fromGetVisibleProjects = false
) => {
  const {
    budget,
    yearComplete,
    projectType,
    projectStatus,
    roomType,
    roomSize,
    pricePackage,
  } = query;
  const budgetOption = _.filter(budget.options, (opt) =>
    _.includes(budget.value, opt.value)
  );

  let yearCompleteOption;
  if (yearComplete.value === "all") {
    yearCompleteOption = [{ max: 2999, min: 1000 }];
  } else {
    yearCompleteOption = _.filter(yearRanges, (opt) => {
      return _.includes(yearComplete.value, `${opt.min}-${opt.max}`);
    });
  }

  const roomTypeQuery = _.get(roomType, "value");
  const roomSizeQuery = _.get(roomSize, "value");
  const pricePackageQuery = _.get(pricePackage, "value");

  const defaultRoomTypeOptions = [
    "Studio",
    "1 Bed",
    "1 Bed Plus",
    "2 Bed",
    "2 Bed Plus",
    "3 Bed",
  ];

  const checkProjectType = (project, projectType) => {
    if (_.isEmpty(_.get(projectType, "value"))) {
      // console.log('empty projectType++');
      return true;
    } else {
      // console.log('projectType++', projectType);
      return _.includes(
        _.get(projectType, "value"),
        _.get(project, "projectType")
      );
    }
  };

  const checkProjectStatus = (project, projectStatus) => {
    if (_.isEmpty(_.get(projectStatus, "value"))) {
      // console.log('empty projectStatus++');
      return true;
    } else {
      // console.log('projectStatus++', projectStatus);
      return _.includes(
        _.get(projectStatus, "value"),
        _.get(project, "projectStatus")
      );
    }
  };

  const extractRoomData = (projects) => {
    // // console.log('projects??', projects);
    let roomData = [];
    _.map(projects, (p) => {
      _.map(_.get(p, "rooms"), (r, ri) => {
        _.map(r, (s, si) => {
          // console.log("will push??", ri, si);

          roomData.push({
            code: _.get(p, "code"),
            roomType: ri,
            roomSize: si,
            capitalGain: _.get(s, "capitalGain"),
            percentSold: _.get(s, "percentSold"),
            rentalPriceSqm: _.get(s, "rentalPriceSqm"),
            rentalYield: _.get(s, "rentalYield"),
            resalePriceSqm: _.get(s, "resalePriceSqm"),
            soldUnits: _.get(s, "soldUnits"),
            startingPrice: _.get(s, "startingPrice"),
            startingResalePrice: _.get(s, "startingResalePrice"),
            totalUnits: _.get(s, "totalUnits"),
            unitsLeft: _.get(s, "unitsLeft"),
          });
        });
      });
    });
    // // console.log('roomData??', roomData);
    return roomData;
  };

  const checkRoomType = (roomData) => {
    if (_.isEmpty(roomTypeQuery)) {
      // console.log('empty roomType++');
      return true;
    } else {
      if (_.includes(roomTypeQuery, "Other")) {
        if (!_.includes(defaultRoomTypeOptions, _.get(roomData, "roomType"))) {
          // console.log('other roomType++');
          return true;
        }
      }
      if (_.includes(roomTypeQuery, _.get(roomData, "roomType"))) {
        // console.log('include roomType++');
        return true;
      }
      // console.log('false roomType++');
      return false;
    }
  };

  const checkRoomSize = (roomData) => {
    // console.log("checkRoomSize roomData??", roomData);
    if (_.isEmpty(roomSizeQuery)) {
      // console.log('empty roomSize++');
      return true;
    } else {
      if (_.includes(roomSizeQuery, ">80")) {
        const splittedSize = _.split(_.get(roomData, "roomSize"));
        if (
          _.toNumber(_.get(splittedSize, "0")) > 80 ||
          _.toNumber(_.get(splittedSize, "1")) > 80
        ) {
          // console.log('>80 roomSize++');
          return true;
        }
      }
      if (_.includes(roomSizeQuery, _.get(roomData, "roomSize"))) {
        // console.log("include roomSize??");
        return true;
      }
      // console.log("false roomSize??");
      return false;
    }
  };

  const checkPricePackage = (rd) => {
    if (_.isEmpty(pricePackageQuery)) {
      // console.log('empty pricePackage++');
      return true;
    } else {
      // // console.log('rd??', rd);
      const startingPrice = _.toNumber(_.get(rd, "startingPrice"));
      if (_.includes(pricePackageQuery, ">10000000")) {
        if (startingPrice > 10000000) {
          // console.log('>10000000 pricePackage++');
          return true;
        }
      }
      for (let i = 0; i < pricePackageQuery.length; i++) {
        if (!_.includes(pricePackageQuery[i], ">")) {
          const splittedPpq = _.split(pricePackageQuery[i], "-");
          if (
            startingPrice >= _.toNumber(_.get(splittedPpq, "0")) &&
            startingPrice <= _.toNumber(_.get(splittedPpq, "1"))
          ) {
            // console.log('include pricePackage++');
            return true;
          }
        }
      }
      // console.log('false pricePackage++');
      return false;
    }
  };

  const filterRoom = (roomData) => {
    const newRoomData = _.filter(roomData, (rd) => {
      return checkRoomType(rd) && checkRoomSize(rd);
    });
    return newRoomData;
  };

  const filterPrice = (roomDataByCode) => {
    return _.filter(roomDataByCode, (rd) => {
      return checkPricePackage(rd);
    });
  };

  const filteredProjects = _.get(state, "newProjects.filteredProjects");
  const tmpResultProjects = _.filter(filteredProjects, (p) => {
    const pp = _.get(p, "location.position", { _lat: 0, _long: 0 });
    const d = getDistance(pp._lat, pp._long, lat, lng);
    let roomTypeList = [];
    _.map(_.get(p, "rooms"), (r) => {
      roomTypeList.push(r);
    });
    
    return (
      d <= 0.001 * radius &&
      checkProjectType(p, projectType) &&
      checkProjectStatus(p, projectStatus) &&
      // && (_.some(budgetOption, bO => {
      //   return _.inRange(p.resalePriceSqm, bO.min, bO.max)
      // }) || _.size(budgetOption) === 0)
      (_.some(yearCompleteOption, (yO) => {
        return _.inRange(_.toNumber(p.yearComplete), yO.min, yO.max + 1);
      }) ||
        _.size(yearCompleteOption) === 0)
    );
  });
  // console.log('projects bf??', projects);
  // console.log("tmpResultProjects??", tmpResultProjects);
  const roomData = extractRoomData(tmpResultProjects);
  // console.log("roomData??", roomData);
  const filteredRoomData = filterRoom(roomData);
  // const filteredRoomData = roomData;
  // console.log("filteredRoomData??", filteredRoomData);

  const roomDataByCode = _(filteredRoomData)
    .groupBy("code")
    .map((data, code) => ({
      code: code,
      startingPrice: _.sumBy(data, "startingPrice") / _.size(data),
    }))
    .value();

  const filteredRoomDataByCode = filterPrice(roomDataByCode);

  const filteredCode = _.map(filteredRoomDataByCode, "code");

  // const lastFilteredRoomData = _.map(filteredRoomData, frd => {
  //   return _.includes(filteredCode, _.get(frd, 'code'));
  // });

  const lastProjectResult = [];
  _.map(tmpResultProjects, (p) => {
    if (
      _.includes(filteredCode, _.get(p, "code")) &&
      (_.some(budgetOption, (bO) => {
        return _.inRange(p.resalePriceSqm, bO.min, bO.max);
      }) ||
        _.size(budgetOption) === 0)
    ) {
      const relatedRoomData = _.filter(filteredRoomData, (f) => {
        return _.get(f, "code") === _.get(p, "code");
      });
      let newP = p;
      let newRoomData = {};
      // console.log("relatedRoomData??", relatedRoomData);
      _.map(relatedRoomData, (rrd) => {
        newRoomData = {
          ...newRoomData,
          [_.get(rrd, "roomType")]: {
            ..._.get(newRoomData, `${_.get(rrd, "roomType")}`),
            [_.get(rrd, "roomSize")]: {
              ...rrd,
            },
          },
        };
      });
      // console.log("newRoomData??", newRoomData);
      newP.rooms = newRoomData;
      // console.log("newP??", newP);
      lastProjectResult.push(newP);
    }
  });
  // console.log("lastProjectResult??", lastProjectResult);
  if (!fromGetVisibleProjects) {
    let lastProjectsObject = {};
    _.map(lastProjectResult, (project, i) => {
      lastProjectsObject[_.get(project, "id")] = {
        ...project,
        rooms: _.get(project, "rooms"),
      };
    });
    dispatch({
      type: "ENTITIES/PROJECTS/REPLACE",
      items: lastProjectsObject,
    });
    const filteredProjectsObject = {};
    const fullProjectsObject = _.get(state, "newProjects.fullProjects");
    _.map(fullProjectsObject, (project, i) => {
      filteredProjectsObject[_.get(project, "id")] = {
        ...project,
        filteredRooms: _.get(project, "fullRooms"),
      };
    });
    dispatch({
      type: "NEWPROJECTS/FILTEREDPROJECTS/REPLACE",
      filteredProjects: filteredProjectsObject,
    });
  }
  // console.log({
  //   lastProjectResult,
  //   tmpResultProjects,
  // });

  return lastProjectResult;
};



// WEBPACK FOOTER //
// ./src/screens/MapScreen/utils.js